
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import FutureLayerLogoMenu from "@/components/Singularity/FutureLayerLogoMenu.vue";
import FutureLayerDaysRemainingBadge from "@/components/Singularity/FutureLayerDaysRemainingBadge.vue";
import { singularityStore } from "@/store/store";

@Component({
  components: {
    FutureLayerLogoMenu,
    FutureLayerDaysRemainingBadge
  }
})
export default class FutureLayerIconAndWarningWrapper extends Vue {
  @Prop({ default: false })
  forceHideExpirationWarning!: boolean;

  get siteState() {
    return singularityStore.siteStatus.siteState;
  }

  get userData() {
    if (this.siteState && "user_data" in this.siteState) {
      return this.siteState.user_data;
    } else {
      return null;
    }
  }

  get accountType() {
    if (!this.userData) {
      return null;
    }

    if (this.userData?.plan_slug === "free") {
      return "free";
    } else {
      return "pro";
    }
  }

  get isClaimed() {
    return singularityStore.siteStatus.isClaimed;
  }

  get hasExpiration() {
    if (!this.siteState || 'error' in this.siteState) return false;
    return this.siteState.expiration !== null && this.siteState.expiration !== undefined;
  }

  get shouldShowBadge() {
    // Only show badge for claimed sites with expiration
    // Don't show when deletion warning is shown (unclaimed sites with expiration)
    return this.hasExpiration && this.isClaimed;
  }
}
